export default __webpack_public_path__ + "static/media/icon-menu-dashboard-active.d54b78f5.svg";